import React, { createContext, useState, useEffect, useContext } from 'react'
import { StateContext } from "../context/StateContext"
import { fetchTemplatesByDevice } from "../helpers/fetchTemplates"

const DEFAULT_TITLES = {
    1: 'Программа №1',
    2: 'Программа №2',
    3: 'Программа №3',
}

export const TemplatesContext = createContext()

/**
 * Контекст программ.
 */
export const TemplatesContextProvider = ({ children }) => {
    const STATE = useContext(StateContext)

    /**
     * Названия программ.
     */
    const [templatesTitles, setTemplatesTitles] = useState({})

    /**
     * Сопоставит названия программ с их идентификатором.
     */
    const fetchingTitles = async () => {
        const templates = await fetchTemplatesByDevice(STATE.lastData.deviceId)

        let titles = {}
        for (let i = 1; i <= 3; i++) {
            const title = templates[i] ? templates[i] : DEFAULT_TITLES[i]
            titles[i] = title
        }

        setTemplatesTitles(titles)
    }

    const renameTemplate = (id, title) => {
        const titles = { ...templatesTitles }

        titles[id] = title.trim()

        console.log('titles', titles)
        setTemplatesTitles(titles)
    }

    /**
     * Загрузит названия программ.
     */
    useEffect(() => {
        if (!!STATE.lastData) {
            fetchingTitles()
        }
    }, [STATE.lastData])

    return (
        <TemplatesContext.Provider
            value={{
                templatesTitles,
                renameTemplate
            }}
        >
            {children}
        </TemplatesContext.Provider>
    );
}